import { useAtom } from 'jotai';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SITE_LINKS } from '../constants';
import { useScreenSize } from '../hooks/use-screen-size';
import { userAtom } from '../jotai-atoms/user.atom';
import { Header } from '../stories/Header';

export interface DefaultHeaderProps {
  activeItem?: string;
}

export const DefaultHeader: React.FC<DefaultHeaderProps> = ({ activeItem = '' }) => {
  const [user] = useAtom(userAtom);
  const __ = useTranslation().t;

  const { width, screenSizes } = useScreenSize();

  const isReferralPageVisible = user?.context?.referralProgramAvailable;

  const createMenuItem = (titleKey: string, href: string) => ({ title: __(titleKey), href });

  const menuItems = useMemo(() => {
    const menuItems = [
      createMenuItem('course', SITE_LINKS.LevelDetailsPage()),
      createMenuItem('progress', SITE_LINKS.LiveClassHistoryPage),
      createMenuItem('help', SITE_LINKS.HelpPage),
    ];

    if (width < screenSizes.lg) {
      menuItems.push(createMenuItem('myProfile', SITE_LINKS.ProfilePage));

      if (isReferralPageVisible) {
        menuItems.push(createMenuItem('referral.name', SITE_LINKS.Share));
      }
    }

    return menuItems;
  }, [width, screenSizes, isReferralPageVisible]);

  const userDropdownItems = useMemo(() => {
    const userDropdownItems = [];

    if (width >= screenSizes.lg) {
      userDropdownItems.push(createMenuItem('myProfile', SITE_LINKS.ProfilePage));
      if (isReferralPageVisible) {
        userDropdownItems.push(createMenuItem('referral.name', SITE_LINKS.Share));
      }
      userDropdownItems.push(createMenuItem('logout', SITE_LINKS.Logout));
    }

    return userDropdownItems;
  }, [width, screenSizes, isReferralPageVisible]);

  return (
    <Header
      type="default"
      logoHref={SITE_LINKS.LevelDetailsPage()}
      user={{ name: user?.firstName || '', imgSrc: user?.profilePicture }}
      isReferralPageVisible={isReferralPageVisible}
      menuItems={menuItems}
      userDropdownItems={userDropdownItems}
      activeItem={activeItem}
    />
  );
};
